import { render, staticRenderFns } from "./SettingInputs.vue?vue&type=template&id=56b3858a&"
import script from "./SettingInputs.vue?vue&type=script&lang=ts&"
export * from "./SettingInputs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports